import { message } from "antd";
import { Translation } from "react-i18next";
import i18next from "i18next";

export function showSuccessToast(textMessage) {
  message.success(i18next.t(textMessage));
}

export function showErrorToast(textMessage) {
  message.error(i18next.t(textMessage));
}
